<template>
	<div style="width: 100%; height: 80%;margin-top: 30px;">
<!--		<a target="blank"-->
<!--			href="https://e.dianping.com/dz-open/merchant/auth?app_key=d3f362a630eacc06&state=teststate&redirect_url=https://admin.ciaojian.com/meituan/authcode">-->
<!--			<el-button type="primary" size="small">美团点评授权</el-button>-->
<!--		</a>-->
<!--		<div style="color: #9c9c9c;">-->
<!--		  <i class="el-icon-warning-outline"></i> 大众点评的授权会过期，过期后将无法核销验券，如果过期了点此登录并授权 账号：Ciaochina-->
<!--		</div>-->
    <div>
      <a target="blank" :href="url" >
        <el-button type="primary" size="small">到店综合</el-button>
      </a>
      <div style="color: #9c9c9c;">
        <i class="el-icon-warning-outline"></i> 美团团购核销的授权会过期，过期后将无法核销验券，如果过期了点击此处授权
      </div>
    </div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
         url: ""
			};
		},
    mounted() {
      this.getUrl();
    },
		methods: {
      getUrl(){
        this.$http.get('meituan/auth').then(res => {
          console.log(res)
          this.url = res.body.data.url
        })
      }
		}
	}
</script>

<style>
</style>
